import { LoadingOutlined } from "@ant-design/icons";
import "./index.less";

type StickyButtonSmallProps = {
  title: string;
  disabled?: boolean;
  backgroundGreen?: boolean;
  isLoading?: boolean;
  handleClickButton: () => void;
};

const StickyButtonSmallComponent: React.FC<StickyButtonSmallProps> = ({
  title,
  disabled = false,
  backgroundGreen = false,
  isLoading = false,
  handleClickButton,
}) => {
  return (
    <div className="sticky-bottom-button-small-container">
      <button
        className={`sticky-bottom-button-small ${backgroundGreen ? "background-green" : ""}`}
        onClick={handleClickButton}
        disabled={disabled}
      >
        {isLoading ? (
          <div className="spinner-container">
            <LoadingOutlined style={{ fontSize: 30, color: "#000000" }} spin />
          </div>
        ) : (
          title
        )}
      </button>
    </div>
  );
};

export default StickyButtonSmallComponent;
